import React, { Fragment, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/it";
import { TEXTFIELD, DATEFIELD, COMBO, SEARCHWINDOW, DYNAMICCOMBO, CHECKBOX, SWITCH, RADIOGROUP } from "../utils/ComponentList";
import SaitTextField from "./SaitTextField";
import SaitDateField from "./SaitDateField";
import { Box } from "@mui/material";
import SaitSearchTextField from "./SaitSearchTextField";
import {
	CONTAINS,
	ENDS_WITH,
	EQUAL,
	IN,
	NOT_NULL,
	NULL,
	STARTS_WITH,
	MULTICOLUMN_IN,
	NUMBER_EQUAL,
	NUMBER_NOT_EQUAL,
	NUMBER_GREATER,
	NUMBER_GREATER_EQUAL,
	NUMBER_LESS,
	NUMBER_LESS_EQUAL,
	DATE_EQUAL,
	DATE_NOT_EQUAL,
	DATE_GREATER,
	DATE_GREATER_EQUAL,
	DATE_LESS,
	DATE_LESS_EQUAL,
	EXTRA_PARAMS,
	NOT_CONTAINS,
} from "../utils/FiltersOperators";
import SaitDynamicCombo from "./SaitDynamicCombo";
import SaitCheckbox from "./SaitCheckbox";
import SaitSwitch from "./SaitSwitch";
import SaitComboFilter from "./SaitComboFilter";
import SaitRadioGroup from "./SaitRadioGroup";

export default function SaitFilters(props) {
	const defaultMinWidth = 150;
	const defaultDateWidth = 140;
	const defaultSize = "small";

	const [valueFilters, setValueFilters] = React.useState([]);

	useEffect(() => {
		updateFilters();
		// eslint-disable-next-line
	}, [JSON.stringify(props.filters)]);

	useEffect(() => {
		createJsonFilter();
		// eslint-disable-next-line
	}, [JSON.stringify(valueFilters)]);

	useEffect(() => {
		createJsonFilter();
		// eslint-disable-next-line
	}, [JSON.stringify(props.gridFilters)]);

	useEffect(() => {
		if (props.resetFilters) {
			resetFilters();
			props.setResetFilters(false);
		}
		// eslint-disable-next-line
	}, [props.resetFilters]);

	useEffect(() => {
		if (props.activateSaveFileters) {
			props.saveNewFilterInCache(valueFilters);
		}
		// eslint-disable-next-line
	}, [props.activateSaveFileters]);

	useEffect(() => {
		if (props.savedGridFilters) {
			setValueFilters(props.savedGridFilters);
			props.setSavedGridFilters(null);
		}
		// eslint-disable-next-line
	}, [props.savedGridFilters]);

	const updateFilters = () => {
		let newValueFilters = [];

		props.filters?.forEach((newFilter, index) => {
			if (newFilter.type === COMBO || newFilter.type === DYNAMICCOMBO) {
				let valueFilter = valueFilters.find((oldValueFilter) => {
					return JSON.stringify(oldValueFilter.name) === JSON.stringify(newFilter.name);
				});

				let comboValue = {};
				if (newFilter.hasOwnProperty("value")) {
					// LA COMBO HA UN VALORE IMPOSTATO
					comboValue = getComboValue(newFilter, newFilter.value);
				} else if (valueFilter?.value?.id || valueFilter?.value?.[0]?.id) {
					// SI STA RENDERIZZANDO UNA COMBO CON UN VALORE GIà SCELTO DALL'UTENTE
					if (newFilter.multiple) {
						comboValue = [];
						valueFilter.value.forEach((value, index) => {
							comboValue.push(value);
						});
					} else {
						comboValue = valueFilter.value;
					}
				} else if (newFilter.defaultValues) {
					// SI STA IMPOSTANDO UN DEFAULTVALUE
					if (newFilter.items?.length > 0) {
						// I VALORI DELLA COMBO SON GIà STATI CARICATI
						if (newFilter.multiple) {
							comboValue = [];
							newFilter.defaultValues.forEach((defaultValue, index) => {
								comboValue.push(getComboValue(newFilter, defaultValue));
							});
						} else {
							comboValue = getComboValue(newFilter, newFilter.defaultValues);
							if (newFilter.afterChange) {
								newFilter.afterChange(comboValue);
							}
						}
					} else {
						// I VALORI DELLA COMBO NON SONO ANCORA STATI CARICATI
						if (newFilter.multiple) {
							comboValue = [];
							newFilter.defaultValues.forEach((defaultValue, index) => {
								comboValue.push(
									defaultValue.reduce((acc, elemento) => {
										acc[elemento.defaultField] = elemento.defaultValue;
										return acc;
									}, {}),
								);
							});
						} else {
							const comboValueReduce = newFilter.defaultValues.reduce((acc, elemento) => {
								acc[elemento.defaultField] = elemento.defaultValue;
								return acc;
							}, {});
							comboValue = comboValueReduce;
							if (newFilter.afterChange) {
								newFilter.afterChange(comboValue);
							}
						}
					}
				}

				newValueFilters.push({
					type: newFilter.type,
					name: newFilter.name,
					operator: newFilter.operator,
					value: comboValue,
				});
			} else if (newFilter.type === SEARCHWINDOW) {
				const valueFilter = valueFilters.find((oldValueFilter) => {
					return JSON.stringify(oldValueFilter.name) === JSON.stringify(newFilter.name);
				});

				let swValue = {};
				let allowWirteValue = null;

				if (newFilter.hasOwnProperty("value")) {
					// LA SW HA UN VALORE IMPOSTATO
					swValue = getComboValue(newFilter, newFilter.value);
				} else if (valueFilter?.value?.id) {
					// SI STA RENDERIZZANDO UNA COMBO CON UN VALORE GIà SCELTO DALL'UTENTE
					swValue = valueFilter.value;
				} else if (valueFilter?.allowwriteValue) {
					// SI STA RENDERIZZANDO UNA COMBO CON UN VALORE GIà SCRITTO DALL'UTENTE
					allowWirteValue = valueFilter.allowwriteValue;
				} else if (newFilter.defaultValues) {
					// SI STA IMPOSTANDO UN DEFAULTVALUE
					if (newFilter.items?.length > 0) {
						// I VALORI DELLA COMBO SON GIà STATI CARICATI
						swValue = getComboValue(newFilter, newFilter.defaultValues);
						if (newFilter.afterChange) {
							newFilter.afterChange(swValue);
						}
					} else {
						// I VALORI DELLA SW NON SONO ANCORA STATI CARICATI
						const swValueReduce = newFilter.defaultValues.reduce((acc, elemento) => {
							acc[elemento.defaultField] = elemento.defaultValue;
							return acc;
						}, {});
						swValue = swValueReduce;
						if (newFilter.afterChange) {
							newFilter.afterChange(swValue);
						}
					}
				}

				newValueFilters.push({
					type: newFilter.type,
					name: newFilter.name,
					operator: newFilter.operator,
					value: swValue,
					allowwriteName: newFilter.allowwrite?.name,
					allowwriteOperator: newFilter.allowwrite?.operator,
					allowwriteValue: allowWirteValue,
				});
			} else if (newFilter.type === RADIOGROUP) {
				let selectedIndex = newFilter.options?.findIndex((option) => option.default);
				if (selectedIndex < 0) {
					selectedIndex = 0; //seleziona il primo
				}
				let selectedRadio = newFilter.options?.[selectedIndex];

				newValueFilters.push({
					type: newFilter.type,
					name: newFilter.name,
					operator: selectedRadio.operator,
					value: selectedRadio.value || selectedRadio.operator || "NO_FILTER",
					selectedIndex: selectedIndex.toString(),
				});
			} else {
				let valueFilter = valueFilters.find((oldValueFilter) => {
					return oldValueFilter.name === newFilter.name && oldValueFilter.operator === newFilter.operator;
				});

				let nullValue = newFilter.type === DATEFIELD ? null : "";

				if (newFilter.hasOwnProperty("customValue")) {
					newValueFilters.push({
						type: newFilter.type,
						name: newFilter.name,
						operator: newFilter.operator,
						value: newFilter.hasOwnProperty("value") ? newFilter.value : valueFilter?.value || newFilter.defaultValue || nullValue,
						customValue: newFilter.customValue,
					});
				} else if (newFilter.hasOwnProperty("customFilter")) {
					let value = newFilter.hasOwnProperty("value") ? newFilter.value : valueFilter?.value || newFilter.defaultValue || nullValue;
					newValueFilters.push({
						type: newFilter.type,
						value: value,
						customFilter: newFilter.customFilter,
					});
				} else {
					newValueFilters.push({
						type: newFilter.type,
						name: newFilter.name,
						operator: newFilter.operator,
						value: newFilter.hasOwnProperty("value") ? newFilter.value : valueFilter?.value || newFilter.defaultValue || nullValue,
					});
				}
			}
		});
		setValueFilters(newValueFilters);
	};

	const resetFilters = () => {
		let newValueFilters = [];

		props.filters?.forEach((newFilter, index) => {
			if (newFilter.type === COMBO || newFilter.type === DYNAMICCOMBO) {
				let comboValue = {};
				if (newFilter.hasOwnProperty("value")) {
					comboValue = getComboValue(newFilter, newFilter.value);
				} else if (newFilter.defaultValues) {
					if (newFilter.multiple) {
						comboValue = [];
						if (newFilter.items?.length > 0) {
							newFilter.defaultValues.forEach((defaultValue, index) => {
								comboValue.push(getComboValue(newFilter, defaultValue));
							});
						}
					} else {
						comboValue = getComboValue(newFilter, newFilter.defaultValues);
						if (newFilter.afterChange) {
							newFilter.afterChange(comboValue);
						}
					}
				}

				newValueFilters.push({
					type: newFilter.type,
					name: newFilter.name,
					operator: newFilter.operator,
					value: comboValue,
				});

				if (newFilter.afterChange) {
					newFilter.afterChange(comboValue);
				}
			} else if (newFilter.type === SEARCHWINDOW) {
				let swValue = {};
				if (newFilter.hasOwnProperty("value")) {
					swValue = getComboValue(newFilter, newFilter.value);
				} else if (newFilter.defaultValues) {
					swValue = getComboValue(newFilter, newFilter.defaultValues);
					if (newFilter.afterChange) {
						newFilter.afterChange(swValue);
					}
				}

				newValueFilters.push({
					type: newFilter.type,
					name: newFilter.name,
					operator: newFilter.operator,
					value: swValue,
					allowwriteName: newFilter.allowwrite?.name,
					allowwriteOperator: newFilter.allowwrite?.operator,
					allowwriteValue: null,
				});

				if (newFilter.afterChange) {
					newFilter.afterChange(swValue);
				}
			} else if (newFilter.type === RADIOGROUP) {
				let selectedIndex = newFilter.options?.findIndex((option) => option.default);
				if (selectedIndex < 0) {
					selectedIndex = 0; //seleziona il primo
				}
				let selectedRadio = newFilter.options?.[selectedIndex];

				newValueFilters.push({
					type: newFilter.type,
					name: newFilter.name,
					operator: selectedRadio.operator,
					value: selectedRadio.value || selectedRadio.operator || "NO_FILTER",
					selectedIndex: selectedIndex.toString(),
				});
			} else {
				let nullValue = newFilter.type === DATEFIELD ? null : "";
				if (newFilter.hasOwnProperty("customFilter")) {
					let value = newFilter.hasOwnProperty("value") ? newFilter.value : newFilter.defaultValue || nullValue;
					newValueFilters.push({
						type: newFilter.type,
						value: value,
						customFilter: newFilter.customFilter,
					});
				} else {
					newValueFilters.push({
						type: newFilter.type,
						name: newFilter.name,
						operator: newFilter.operator,
						value: newFilter.hasOwnProperty("value") ? newFilter.value : newFilter.defaultValue || nullValue,
					});
				}

				if (newFilter.afterChange) {
					let newValue = newFilter.hasOwnProperty("value") ? newFilter.value : newFilter.defaultValue || nullValue;
					newFilter.afterChange(newValue);
				}
			}
		});

		props.setGridFilters([]);

		setValueFilters(newValueFilters);
	};

	const getComboValue = (combo, value) => {
		let comboValue = {};
		combo.items?.some((item) => {
			let rightItem = true;
			value.forEach((defaultValue, index) => {
				if (item[defaultValue.defaultField] !== defaultValue.defaultValue) {
					rightItem = false;
				}
			});

			if (rightItem) {
				comboValue = item;
				return true;
			}
			return false;
		});
		return comboValue;
	};

	const createJsonFilter = () => {
		let jsonFilters = [];
		valueFilters.forEach((filter) => {
			if (filter.value || filter.value === 0) {
				if (filter.type === COMBO || filter.type === DYNAMICCOMBO) {
					if (Array.isArray(filter.value)) {
						// COMBO MULTIPLE
						if (filter.value.length > 0) {
							const gridNamesArray = filter.name.map((singleName) => singleName.storeName);

							const comboNamesArray = filter.name.map((singleName) => singleName.comboName);

							const valuesArray = comboNamesArray.map((name) => filter.value.map((singleValue) => singleValue[name]));
							jsonFilters.push({
								field: gridNamesArray,
								operator: filter.operator === EXTRA_PARAMS ? EXTRA_PARAMS : MULTICOLUMN_IN,
								value: valuesArray,
							});
						}
					} else {
						if (filter.value !== "ReloadComboJsws") {
							if (Object.values(filter.value).some((item) => item !== "")) {
								filter.name.forEach((field) => {
									jsonFilters.push({
										field: field.storeName,
										operator: filter.operator || EQUAL,
										value: filter.value[field.comboName],
									});
								});
							}
						}
					}
				} else if (filter.type === SEARCHWINDOW) {
					if (filter.allowwriteValue) {
						jsonFilters.push({
							field: filter.allowwriteName,
							operator: filter.allowwriteOperator,
							value: filter.allowwriteValue,
						});
					} else if (Object.values(filter.value).some((item) => item !== "")) {
						filter.name.forEach((field) => {
							jsonFilters.push({
								field: field.storeName,
								operator: filter.operator || EQUAL,
								value: filter.value[field.gridName],
							});
						});
					}
				} else if (filter.type === RADIOGROUP) {
					if (filter.value !== "NO_FILTER") {
						jsonFilters.push({
							field: filter.name,
							operator: filter.operator,
							value: filter.value,
						});
					}
				} else if (filter.type === SWITCH) {
					return;
				} else if (filter.type === CHECKBOX && filter.customFilter) {
					if (filter.value && filter.customFilter.checked) {
						jsonFilters.push({
							field: filter.customFilter.checked.name,
							operator: filter.customFilter.checked.operator,
							value: filter.customFilter.checked.value,
						});
					} else if (filter.customFilter.unchecked) {
						jsonFilters.push({
							field: filter.customFilter.unchecked.name,
							operator: filter.customFilter.unchecked.operator,
							value: filter.customFilter.unchecked.value,
						});
					}
				} else {
					let filterValue = filter.hasOwnProperty("customValue") ? filter.customValue(filter.value) : filter.value;

					if (Array.isArray(filter.name)) {
						let itemsGroup = [];

						filter.name.forEach((name) => {
							itemsGroup.push({
								field: name,
								operator: filter.operator,
								value: filterValue,
							});
						});

						jsonFilters.push({
							groupItem: itemsGroup,
							groupOperator: "AND",
						});
					} else {
						jsonFilters.push({
							field: filter.name,
							operator: filter.operator,
							value: filterValue,
						});
					}
				}
			}
		});

		props.gridFilters?.forEach((gridFilter) => {
			if (gridFilter.operator === "isEmpty" || gridFilter.operator === "isNotEmpty") {
				jsonFilters.push({
					field: gridFilter.field,
					operator: getSaitOperator(gridFilter.operator),
					value: null,
				});
			} else {
				if (gridFilter.value || gridFilter.value === 0) {
					let value = gridFilter.value;

					if (
						gridFilter.operator === "is" ||
						gridFilter.operator === "not" ||
						gridFilter.operator === "after" ||
						gridFilter.operator === "onOrAfter" ||
						gridFilter.operator === "before" ||
						gridFilter.operator === "onOrBefore"
					) {
						value = new Date(value).toISOString();
					}

					jsonFilters.push({
						field: gridFilter.field,
						operator: getSaitOperator(gridFilter.operator),
						value: value,
					});
				}
			}
		});

		if (valueFilters.length === props.filters?.length) {
			props.impostaFiltri(jsonFilters);
		}
	};

	const getSaitOperator = (gridOperator) => {
		switch (gridOperator) {
			case "contains":
				return CONTAINS;
			case "doesNotContain":
				return NOT_CONTAINS;
			case "equals":
				return EQUAL;
			case "startsWith":
				return STARTS_WITH;
			case "endsWith":
				return ENDS_WITH;
			case "isEmpty":
				return NULL;
			case "isNotEmpty":
				return NOT_NULL;
			case "isAnyOf":
				return IN;
			case "=":
				return NUMBER_EQUAL;
			case "!=":
				return NUMBER_NOT_EQUAL;
			case ">":
				return NUMBER_GREATER;
			case ">=":
				return NUMBER_GREATER_EQUAL;
			case "<":
				return NUMBER_LESS;
			case "<=":
				return NUMBER_LESS_EQUAL;
			case "is":
				return DATE_EQUAL;
			case "not":
				return DATE_NOT_EQUAL;
			case "after":
				return DATE_GREATER;
			case "onOrAfter":
				return DATE_GREATER_EQUAL;
			case "before":
				return DATE_LESS;
			case "onOrBefore":
				return DATE_LESS_EQUAL;

			default:
				return CONTAINS;
		}
	};

	/* Filtro Checkbox: vengono restituiti i record a Y oppure TUTTI i record della find */
	const onChangeCheckBoxFilter = (e, index, afterChange) => {
		const newFilters = [...valueFilters];
		if (e === "Y") {
			newFilters[index].value = e;
		} else {
			newFilters[index].value = undefined;
		}
		setValueFilters(newFilters);

		if (afterChange) {
			afterChange(e);
		}
	};

	const onChangeRadioFilter = (newValue, newOperator, filtersIndex, selectedIndex, afterChange) => {
		const newFilters = [...valueFilters];
		newFilters[filtersIndex].value = newValue;
		newFilters[filtersIndex].operator = newOperator;
		newFilters[filtersIndex].selectedIndex = selectedIndex.toString();
		setValueFilters(newFilters);

		if (afterChange) {
			afterChange(newValue);
		}
	};

	const onChangeFilter = (e, index, afterChange) => {
		const newFilters = [...valueFilters];
		newFilters[index].value = e;
		setValueFilters(newFilters);

		if (afterChange) {
			afterChange(e);
		}
	};

	const onChangeComboFilter = (selection, index, multiple, afterChange) => {
		const newFilters = [...valueFilters];

		if (multiple) {
			if (selection?.length > 0) {
				newFilters[index].value = selection;
			} else {
				newFilters[index].value = [];
			}
		} else {
			if (selection) {
				newFilters[index].value = selection;
			} else {
				newFilters[index].value = {};
			}
		}

		setValueFilters(newFilters);

		if (afterChange) {
			afterChange(selection);
		}
	};

	const onChangeSWFilter = (allowwrite, newValue, index, afterChange) => {
		const newFilters = [...valueFilters];

		if (typeof newValue === "object" && !Array.isArray(newValue) && newValue) {
			newFilters[index].value = newValue;
			newFilters[index].allowwriteValue = null;
		} else if (typeof newValue === "string" && allowwrite?.name && newValue) {
			newFilters[index].value = {};
			newFilters[index].allowwriteValue = newValue;
		} else {
			newFilters[index].value = {};
			newFilters[index].allowwriteValue = null;
		}

		setValueFilters(newFilters);

		if (afterChange) {
			afterChange(newValue);
		}
	};

	const onChangeDateFilter = (newValue, index, afterChange, time) => {
		const newFilters = [...valueFilters];
		let formattedValue = null;
		if (newValue) {
			if (!isNaN(newValue.$D)) {
				formattedValue = dayjs(newValue);

				if (!time) {
					// Porta la data a mezzanotte
					formattedValue = formattedValue.startOf("day");
				}
			}
		}
		newFilters[index].value = formattedValue;
		setValueFilters(newFilters);

		if (afterChange) {
			afterChange(newValue, formattedValue);
		}
	};

	/* 	const onChangeSwitchFilter = (e, index) => {
		const newFilters = [...valueFilters];
		if (e === true) {
			newFilters[index].value = e;
		} else {
			newFilters[index].value = undefined;
		}
		setValueFilters(newFilters);
	}; */

	const onClearFilter = (index) => {
		const newFilters = [...valueFilters];
		newFilters[index].value.forEach((value, indexValue) => {
			newFilters[index].value[indexValue] = "";
		});
		setValueFilters(newFilters);
	};

	const overrideComboValues = (valueIndex, newValues) => {
		// Serve perchè nelle combo multiple con defaultValues, i tags rimanevano vuoti
		// Sovrascrivo i value passati dal defaultValues con i relativi record caricati a database
		const newFilters = [...valueFilters];

		newFilters[valueIndex].value = newValues;

		setValueFilters(newFilters);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexWrap: "wrap",
				gap: "10px",
				alignItems: "center",
			}}
		>
			{props.filters?.map((filter, index) => (
				<Fragment key={index}>
					{filter.type ? (
						filter.type === TEXTFIELD ? (
							<SaitTextFieldFilters
								{...filter}
								label={filter.label}
								value={valueFilters[index]?.value || ""}
								sx={{
									flex: filter.width ? null : "1 0 " + (filter.minwidth || defaultMinWidth) + "px",
									width: filter.width ? filter.width : "100%",
								}}
								size={filter.size || defaultSize}
								onChange={(e) => onChangeFilter(e, index, filter.afterChange)}
								customkeydownfilters={(event) => {
									if (event.key === "Enter") {
										event.preventDefault();
										props.handleFireFilter();
									}
								}}
							/>
						) : filter.type === DATEFIELD ? (
							<SaitDateField
								{...filter}
								label={filter.label}
								value={valueFilters[index]?.value || null}
								onChange={(newDate) => onChangeDateFilter(newDate, index, filter.afterChange, filter.time)}
								sx={{
									flex: null,
									width: filter.width ? filter.width : defaultDateWidth,
								}}
								size={filter.size || defaultSize}
								onKeyDown={(event) => {
									if (event.key === "Enter") {
										event.preventDefault();
										props.handleFireFilter();
									}
								}}
							/>
						) : filter.type === COMBO ? (
							<SaitComboFilter
								{...filter}
								label={filter.label}
								value={valueFilters[index]?.value || (filter.multiple ? [] : {})}
								overrideValues={(newValues) => overrideComboValues(index, newValues)}
								sx={{
									flex: filter.width ? null : "1 0 " + (filter.minwidth || defaultMinWidth) + "px",
									width: filter.width ? filter.width : "100%",
									maxWidth: filter.maxWidth || "400px",
								}}
								onClear={() => onClearFilter(index)}
								onChange={(row) => onChangeComboFilter(row, index, filter.multiple, filter.afterChange)}
								size={filter.size}
								description={filter.description}
								name={filter.name}
								findParameters={filter.findParameters}
								items={filter.items}
								multiple={filter.multiple}
								limitTags={filter.limitTags}
								required={filter.required}
								disabled={filter.disabled}
								objmod={filter.objmod}
							/>
						) : filter.type === DYNAMICCOMBO ? (
							<SaitDynamicCombo
								{...filter}
								value={valueFilters[index]?.value || {}}
								sx={{
									flex: filter.width ? null : "1 0 " + (filter.minwidth || defaultMinWidth) + "px",
									width: filter.width ? filter.width : "100%",
								}}
								index={index}
								onClear={() => onClearFilter(index)}
								filterCombo={true}
								valueFilters={valueFilters}
								setValueFilters={setValueFilters}
							/>
						) : filter.type === SEARCHWINDOW ? (
							<SaitSearchTextField
								{...filter}
								key={index}
								label={filter.label}
								value={(filter.allowwrite?.name && valueFilters[index]?.allowwriteValue ? valueFilters[index]?.allowwriteValue : valueFilters[index]?.value) || {}}
								name={filter.name}
								sx={{
									flex: filter.width ? null : "1 0 " + (filter.minwidth || defaultMinWidth) + "px",
									width: filter.width ? filter.width : "100%",
								}}
								onChange={(newValue) => onChangeSWFilter(filter.allowwrite, newValue, index, filter.afterChange)}
								searchWindow={filter.searchWindow}
								size={filter.size}
								description={filter.description}
								filterSearchWindow={true}
								noClearable={filter.noClearable}
								allowwrite={filter.allowwrite}
								onKeyDown={(event) => {
									if (event.key === "Enter") {
										event.preventDefault();
										props.handleFireFilter();
									}
								}}
							/>
						) : filter.type === CHECKBOX ? (
							<SaitCheckbox
								{...filter}
								key={index}
								label={filter.label}
								value={valueFilters[index]?.value || "N"}
								disabled={filter.disabled}
								onChange={(checked) => {
									onChangeCheckBoxFilter(checked, index, filter.afterChange);
								}}
							/>
						) : filter.type === SWITCH ? (
							<SaitSwitch
								{...filter}
								key={index}
								startLabel={filter.startLabel || null}
								endLabel={filter.endLabel || null}
								checked={valueFilters[index]?.value || false}
								onChange={(checked) => {
									filter.onChange(checked);
								}}
							/>
						) : filter.type === RADIOGROUP ? (
							<SaitRadioGroup
								{...filter}
								key={index}
								label={filter.label}
								options={filter.options}
								value={valueFilters[index]?.selectedIndex || {}}
								onChange={(newValue, newOperator, selectedIndex) => {
									onChangeRadioFilter(newValue, newOperator, index, selectedIndex, filter.afterChange);
								}}
								filter={true}
							/>
						) : null
					) : null}
				</Fragment>
			))}
			{props.filterButton}
		</Box>
	);
}

function SaitTextFieldFilters(props) {
	const { value, onChange, onEnter, ...textfieldProps } = props;

	const [internalValue, setInternalValue] = useState(value ?? "");
	const debounceTime = 200;
	const debounceTimer = useRef(null);

	const handleChangeValue = (e) => {
		const newValue = e.target.value;

		setInternalValue(newValue);

		// reset debounce
		if (debounceTimer.current) {
			clearTimeout(debounceTimer.current);
		}

		debounceTimer.current = setTimeout(() => {
			onChange?.(newValue);
		}, debounceTime);
	};

	const handleKeyDown = (e) => {
		// Se sto facendo un debounce aspetto che finisca prima di filtrare
		if (debounceTimer.current) {
			setTimeout(() => {
				props.customkeydownfilters?.(e);
			}, debounceTime);
		} else {
			props.customkeydownfilters?.(e);
		}
	};

	// sincronizza quando props.value cambia da fuori
	useEffect(() => {
		if (value !== internalValue) {
			setInternalValue(value ?? "");
		}
	}, [value]);

	// pulizia del timer su smontaggio
	useEffect(() => {
		return () => {
			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
		};
	}, []);

	// eslint-disable-next-line no-unused-vars
	const { customkeydownfilters, ...restTextFieldProps } = textfieldProps;

	return (
		<SaitTextField
			{...restTextFieldProps}
			value={internalValue}
			onChange={handleChangeValue}
			type={textfieldProps.tipo}
			// InputLabelProps={internalValue ? { shrink: true } : {}}
			onKeyDown={(event) => {
				if (event.key === "Enter") {
					handleKeyDown(event);
				}
			}}
		/>
	);
}
